const NAME_COLORS = [
  "#ffd98a",
  "#ff9a6b",
  "#7dd3fc",
  "#c4b5fd",
  "#86efac",
  "#f9a8d4",
  "#fda4af",
  "#a5b4fc",
];

export function nameColor(userId: string): string {
  let hash = 0;
  for (let i = 0; i < userId.length; i += 1) {
    hash = (hash * 31 + userId.charCodeAt(i)) >>> 0;
  }
  return NAME_COLORS[hash % NAME_COLORS.length]!;
}

export function formatChatTime(iso: string): string {
  const date = new Date(iso);
  return date.toLocaleTimeString("ru-RU", { hour: "2-digit", minute: "2-digit" });
}
